import type { FormatOptions } from "date-fns";
import { format } from "date-fns";
import type { OpaqueColorValue, StyleProp, TextStyle } from "react-native";
import { StyleSheet, Text, View } from "react-native";

import { Icon } from "./Icon";

export type DateIndicatorProps = {
  currentDate?: Date;
  dayFormat?: string;
  dateFormat?: string;
  formatOptions?: FormatOptions;
  iconColor?: string | OpaqueColorValue;
  textStyle?: StyleProp<TextStyle>;
};

export const DateIndicator = ({
  currentDate,
  dayFormat,
  dateFormat,
  formatOptions,
  iconColor,
  textStyle,
}: DateIndicatorProps) => {
  currentDate ??= new Date();
  dayFormat ??= "EEEE";
  dateFormat ??= "MM-dd-yyyy";

  const formattedDay = format(currentDate, dayFormat, formatOptions);
  const formattedDate = format(currentDate, dateFormat, formatOptions);

  return (
    <View style={styles.container}>
      <Icon
        iconSet="material-community"
        icon="calendar-range-outline"
        size={24}
        color={iconColor}
      />
      <View>
        <Text style={[styles.text, textStyle]}>{formattedDay}</Text>
        <Text style={[styles.text, textStyle]}>{formattedDate}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 4,
    paddingHorizontal: 12,
    gap: 12,
    height: 32,
  },
  text: {
    fontSize: 14,
    lineHeight: 18,
  },
});
